import React, { useState } from 'react'
import { Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { exportTableRows, type ExportColumn } from './exportTableRows.ts'

interface ExportRowsButtonProps<T> {
  /** File name stem: the file is `<name> - <YYYY-MM-DD>.xlsx`. */
  name: string
  /** The rows the grid shows, in its order. */
  rows: readonly T[]
  columns: ExportColumn<T>[]
}

/**
 * The Export button of a hand-coded grid, for the section's `headerActions`:
 * small, `DownloadOutlined`, disabled while the grid has no rows. Columns are
 * read on click, so an inline `columns` array costs nothing per render.
 */
export function ExportRowsButton<T>({ name, rows, columns }: ExportRowsButtonProps<T>): React.ReactElement {
  const [loading, setLoading] = useState(false)
  return (
    <Button
      size='small'
      icon={<DownloadOutlined />}
      disabled={rows.length === 0}
      loading={loading}
      onClick={async () => {
        setLoading(true)
        try {
          await exportTableRows({ name, rows, columns })
        } finally {
          setLoading(false)
        }
      }}
    >
      Export
    </Button>
  )
}

export default ExportRowsButton
